<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div id="input-class"
                        class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">

                            <TheInputText title="Họ tên" placeholder="Tìm theo họ tên" :initialValue="sValue_HOTEN"
                                v-model="sValue_HOTEN" :isRequire=false :key="tempKey"
                                @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Tên tài khoản" placeholder="Tìm theo tên tài khoản"
                                :initialValue="sValue_TENTAIKHOAN" v-model="sValue_TENTAIKHOAN" :isRequire=false
                                :key="tempKey" @onChange="v => handlePageChange(1)" />


                        </div>


                        <div class="col mb-3">

                            <TheSelect title="Đơn vị" :options="category_DONVI" :initialValue="sValue_DONVI"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => searchChangeDonVi(v)" />
                        </div>

                        <div class="col mb-3">

                            <TheSelect title="Chức danh" :options="category_CHUCDANH" :initialValue="sValue_CHUCDANH"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => searchChangeChucDanh(v)" />
                        </div>

                        <div class="col mb-3">
                            <div class="form-group">
                                <label>
                                    <span>Tình trạng khóa</span>
                                </label>
                                <select id="LockoutEnabled_sOptions" class="form-control select2bs4"
                                    style="width: 100%">
                                    <option :value=null>--- Tất cả ---</option>
                                    <option :value=true>Bật</option>
                                    <option :value=false>Tắt</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == 1">Danh sách hiện hành</b>
                        <b v-if="sType_List == 2">Danh sách đã xóa</b>
                    </h3>
                    <div class="card-tools">
                        <button v-if="sType_List == '2'" type="button" class="btn btn-tool"
                            title="Chuyển sang danh sách hiện hành" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == '1'" type="button" class="btn btn-tool"
                            title="Chuyển sang danh sách đã xóa" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == '2'" class="dropdown-item text-green" href="#"
                                        @click="confirmList('restore')" :title="$t('labels.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('labels.restore') }}</a>
                                    <div class="dropdown-d ivider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('delete')" :title="$t('labels.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('labels.delete')
                                        }}</a>
                                    <a v-if="sType_List == '2'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('deleteReal')" :title="$t('labels.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('labels.deleteReal')
                                        }}</a>
                                    <!-- <div class="dropdown-d ivider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-green" href="#" @click="confirmList('onEnabled')"
                                        title="Bật hiển thị trên Cổng"><i class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        Mở khóa tài khoản</a>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#" @click="confirmList('offEnabled')"
                                        title="Ẩn hiển thị trên Cổng"><i class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        Khóa tài khoản</a> -->
                                    <export-excel v-if="sType_List == '1'" class="dropdown-item text-green"
                                        :data="exportDatas" :fields="exportJsonFields" :before-generate="exportExcel"
                                        worksheet="NguoiDung" type="xls" name="NguoiDungExport.xls">
                                        <i class="fas fa-file-export"></i>&nbsp;&nbsp;{{ $t('labels.exportExcel') }}
                                    </export-excel>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-green" href="#"
                                        @click="showImportModal()" :title="$t('labels.importExcel')">
                                        <i class="fas fa-file-import"></i>&nbsp;&nbsp;{{ $t('labels.importExcel') }}</a>
                                    <div class="dropdown-divider"></div>
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, 'create')"
                            v-bind:title="$t('labels.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                        <!-- <button type="button" class="btn btn-tool" @click="getData" v-bind:title="$t('labels.reload')">
                    </button> -->
                        <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse"
                        v-bind:title="$t('labels.collapse')">
                        <i class="fas fa-minus"></i>
                    </button> -->
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col50">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('userName')">
                                        Tên tài khoản
                                        <span v-if="(orderDesc == false && sortBy == 'userName')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'userName')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('hoTen')">
                                        Họ tên người dùng
                                        <span v-if="(orderDesc == false && sortBy == 'hoTen')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'hoTen')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50">
                                        Giới tính
                                    </th>
                                    <th class="col50">
                                        Email
                                    </th>
                                    <th class="col50">
                                        Số điện thoại
                                    </th>
                                    <th class="col50">
                                        Đơn vị
                                    </th>
                                    <th class="col50">
                                        Chức danh
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('appId')">
                                        Quyền phân hệ
                                        <span v-if="(orderDesc == false && sortBy == 'appId')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'appId')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Thời gian khóa</th>
                                    <th class="col50">Tình trạng khóa</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td @click="selectRow(item.userId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList.includes(item.userId))" aria-hidden="true"
                                            class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td>{{ item.userName }}</td>
                                    <td>{{ item.hoTen }}</td>
                                    <td v-if="item.gioiTinh == 0">Nam</td>
                                    <td v-else-if="item.gioiTinh == 1">Nữ</td>
                                    <td v-else></td>
                                    <td>{{ item.email }}</td>
                                    <td>{{ item.sdt }}</td>
                                    <td>{{ item.tenDonVi }}</td>
                                    <td>{{ item.tenChucDanh }}</td>
                                    <td>{{ item.appName }}</td>
                                    <td>{{ item.lockoutTime }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == 2" :id="'item' + item.userId"
                                                v-model="item.lockoutEnabledDisplay"
                                                v-on:click="openConfirmLockoutEnabledChange(item)">
                                            <label class="custom-control-label" :for="'item' + item.userId"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="sType_List == 1">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, 'reset')" title="Khóa tài khoản">
                                                <i class="fas fa-key"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, 'detail')" title="Xem chi tiết">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == 1">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, 'update')" title="Cập nhật">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, 'delete')" title="Xóa">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;
                                        <button v-if="sType_List == 2" type="button" size="sm"
                                            class="btn btn-outline-warning btn-xs" v-on:click="detail(item, 'restore')"
                                            title="Khôi phục">
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-primary">{{ title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hideModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Tên tài khoản" placeholder="Nhập tên tài khoản"
                                        :initialValue="model.userName" v-model="model.userName" :error="errors.userName"
                                        :isReadOnly="isReadonlyUserName" :isRequire=true :isMultipleLine="false"
                                        :key="tempKey" />
                                </div>
                            </div>

                            <div class="row" v-if="code == 'create'">
                                <div class="col-md-12">
                                    <TheInputText title="Mật khẩu" placeholder="Nhập mật khẩu"
                                        :initialValue="model.password" v-model="model.password" :error="errors.password"
                                        :isReadOnly="isReadonly" :isRequire=true :isMultipleLine="false" type="password"
                                        :key="tempKey" />
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Họ tên" placeholder="Nhập họ tên" :initialValue="model.hoTen"
                                        v-model="model.hoTen" :error="errors.hoTen" :isReadOnly="isReadonly"
                                        :isRequire=true :isMultipleLine="true" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Giới tính" :options="category_GIOITINH"
                                        :dropdownParent="modalName" :initialValue="model.gioiTinh"
                                        :error="errors.gioiTinh" :isMultiple="false" :isReadOnly="isReadonly"
                                        :isAllowClear="true" :isRequire=false @onChange="(e) => { model.gioiTinh = e }"
                                        :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Email" placeholder="Nhập email" :initialValue="model.email"
                                        v-model="model.email" :error="errors.email" :isReadOnly="isReadonly"
                                        :isRequire=false :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Số điện thoại" placeholder="Nhập số điện thoại"
                                        :initialValue="model.sdt" v-model="model.sdt" :error="errors.sdt"
                                        :isReadOnly="isReadonly" :isRequire=true :isMultipleLine="false"
                                        :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Đơn vị" :options="category_DONVI" :dropdownParent="modalName"
                                        :initialValue="model.donViId" :error="errors.donViId" :isMultiple="false"
                                        :isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
                                        @onChange="(e) => { model.donViId = e }" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Chức danh" :options="category_CHUCDANH"
                                        :dropdownParent="modalName" :initialValue="model.chucDanhId"
                                        :error="errors.chucDanhId" :isMultiple="false" :isReadOnly="isReadonly"
                                        :isAllowClear="true" :isRequire=false
                                        @onChange="(e) => { model.chucDanhId = e }" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Quận huyện" :options="category_cQUANHUYEN"
                                        :dropdownParent="modalName" :initialValue="model.quanHuyenId"
                                        :error="errors.quanHuyenId" :isMultiple="false" :isReadOnly="isReadonly"
                                        :isAllowClear="true" :isRequire=false @onChange="(v) => onChange_cQuanHuyen(v)"
                                        :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Phường xã" :options="category_cPHUONGXA"
                                        :dropdownParent="modalName" :initialValue="model.phuongXaId"
                                        :error="errors.phuongXaId" :isMultiple="false" :isReadOnly="isReadonly"
                                        :isAllowClear="true" :isRequire=false @onChange="(v) => onChange_cPhuongXa(v)"
                                        :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Khóm ấp" :options="category_cKHOMAP" :dropdownParent="modalName"
                                        :initialValue="model.khomApId" :error="errors.khomApId" :isMultiple="false"
                                        :isReadOnly="isReadonly" :isAllowClear="true" :isRequire=false
                                        @onChange="(v) => onChange_cKhomAp(v)" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Tổ dân phố" :options="category_cTODANPHO"
                                        :dropdownParent="modalName" :initialValue="model.toDanPhoId"
                                        :error="errors.toDanPhoId" :isMultiple="false" :isReadOnly="isReadonly"
                                        :isAllowClear="true" :isRequire=false
                                        @onChange="(e) => { model.toDanPhoId = e }" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Đường phố" :options="category_DUONGPHO"
                                        :dropdownParent="modalName" :initialValue="model.duongPhoId"
                                        :error="errors.duongPhoId" :isMultiple="false" :isReadOnly="isReadonly"
                                        :isAllowClear="true" :isRequire=false
                                        @onChange="(e) => { model.duongPhoId = e }" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Số nhà" placeholder="Nhập số nhà" :initialValue="model.soNha"
                                        v-model="model.soNha" :error="errors.soNha" :isReadOnly="isReadonly"
                                        :isRequire=false :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Địa chỉ" placeholder="Nhập địa chỉ"
                                        :initialValue="model.diaChi" v-model="model.diaChi" :error="errors.diaChi"
                                        :isReadOnly="isReadonly" :isRequire=false :isMultipleLine="false"
                                        :key="tempKey" />
                                </div>
                            </div>

                            <!-- <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Phân hệ" :options="category_cPHANHE" :dropdownParent="modalName"
                                        :initialValue="model.appId" :error="errors.appId" :isMultiple="false"
                                        :isReadOnly="isReadonly" :isAllowClear="true" :isRequire=true
                                        @onChange="(v) => onChange_cPhanHe(v)" :key="tempKey" />
                                </div>
                            </div> -->

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Quyền" :options="category_cQUYEN" :dropdownParent="modalName"
                                        :initialValue="dValue_QUYEN" :error="errors.listRoleId" :isMultiple="true"
                                        :isReadOnly="isReadonly" :isAllowClear="true" :isRequire=true
                                        @onChange="(v) => changeQuyen(v)" :key="tempKey" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hideModal()">&nbsp;Đóng</button>

                            <button type="button" class="pull-right" :class="styleButton" v-if="code != 'detail'"
                                @click="onSubmit();">&nbsp;{{ title }}</button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal fade" id="resetPasswordModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-primary">Reset mật khẩu</h4>
                            <button type="button" class="close" aria-label="Close" @click="hideResetPasswordModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            Mật khẩu mới <span class="text-danger">(*)</span>
                                        </label>

                                        <input type="password" class="form-control" placeholder="Nhập mật khẩu mới"
                                            v-model="modelResetPassword.password"
                                            :class="{ 'is-invalid': modelResetPassword.errorPassword }" />
                                        <div class="text-danger text-right" v-if="modelResetPassword.errorPassword">
                                            {{ modelResetPassword.errorPassword }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            Xác nhận mật khẩu <span class="text-danger">(*)</span>
                                        </label>
                                        <input type="password" class="form-control" placeholder="Nhập xác nhận mật khẩu"
                                            v-model="modelResetPassword.confirmPassword"
                                            :class="{ 'is-invalid': modelResetPassword.errorConfirmPassword }" />
                                        <div class="text-danger text-right"
                                            v-if="modelResetPassword.errorConfirmPassword">
                                            {{ modelResetPassword.errorConfirmPassword }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hideResetPasswordModal()">&nbsp;Đóng</button>

                            <button type="button" class="pull-right btn btn-outline-success" v-if="code != 'detail'"
                                @click="onResetPasswordSubmit();">&nbsp;Reset mật khẩu</button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelRec">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <div>
                                        <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin chung:</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Tài khoản ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.userId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên tài khoản
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.userName }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Giới tính
                                        <b class="d-block" v-if="modelRec.gioiTinh == 0">&nbsp;&nbsp;&nbsp;Nam&nbsp;</b>
                                        <b class="d-block"
                                            v-else-if="modelRec.gioiTinh == 1">&nbsp;&nbsp;&nbsp;Nam&nbsp;</b>
                                        <b class="d-block" v-else>&nbsp;&nbsp;&nbsp;&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Số điện thoại
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.sdt }}&nbsp;</b>
                                    </p>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Đơn vị
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenDonVi }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Chức danh
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenChucDanh }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Tình trạng khóa
                                        <b class="d-block" v-if="modelRec.lockoutEnabled == 1">&nbsp;&nbsp;&nbsp;Đang bị
                                            Khóa - Thời gian khóa: {{ modelRec.lockoutTime }}&nbsp;</b>
                                        <b class="d-block"
                                            v-else-if="modelRec.lockoutEnabled == 0">&nbsp;&nbsp;&nbsp;Không bị
                                            khóa&nbsp;</b>
                                        <b class="d-block" v-else>&nbsp;&nbsp;&nbsp;&nbsp;</b>
                                    </p>

                                </div>
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <div>
                                        <hr />
                                        <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Địa chỉ:</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Quận huỵên
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenQuanHuyen }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Phường xã
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenPhuongXa }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Khóm ấp
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenKhomAp }}&nbsp;</b>
                                    </p>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Tổ dân phố
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenToDanPho }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Đường phố
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenDuongPho }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Số nhà
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.soNha }}&nbsp;</b>
                                    </p>
                                </div>

                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <p class="text-sm">Địa chỉ
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.diaChi }}&nbsp;</b>
                                    </p>
                                </div>
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <div>
                                        <hr />
                                        <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Quyền tài khoản:</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Phân hệ
                                        <b class="d-block" v-if="modelRec.appInfo" v-for="item in modelRec.appInfo"
                                            :key="item.appId">
                                            &nbsp;&nbsp;&nbsp;- {{ item.appName }}
                                        </b>&nbsp;
                                    </p>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">

                                    <p class="text-sm">Danh sách quyền
                                        <b class="d-block" v-if="modelRec.roleInfo" v-for="item in modelRec.roleInfo"
                                            :key="item.id">
                                            &nbsp;&nbsp;&nbsp;- {{ item.ten }}
                                        </b>&nbsp;
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">{{ csList_Title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupconfirmcsListModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <p class="text-sm">Bạn có chắc chắn <b>{{ csList_Title }}</b> các dữ liệu đã chọn?</p>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hidePopupconfirmcsListModal">&nbsp;{{
                                    $t('buttons.close') }}</button>
                            <button type="button" class="btn btn-outline-danger pull-right"
                                @click=" onSubmitList();">&nbsp;{{ csList_Title }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="lockoutEnabledConfirmModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-danger" style="text-transform:uppercase;">XÁC NHẬN</h4>
                            <button type="button" class="close" aria-label="Close"
                                @click="closeConfirmLockOutEnabledChange()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <p class="text-md">Bạn có chắc chắn muốn <b>{{ cLockoutEnable_Title }}</b> tài khoản
                                    <b>{{ cLockoutEnable_Value ? cLockoutEnable_Value.userName : "" }}</b> ?
                                </p>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="closeConfirmLockOutEnabledChange()">&nbsp;Thoát</button>
                            <button type="button" class="btn btn-outline-danger pull-right"
                                @click=" updateLockoutEnabled();">&nbsp;Xác nhận</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- POP UP IMPORT EXCEL  -->
            <div class="modal fade" id="importModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-danger">Import</h4>
                            <button type="button" class="close" aria-label="Close" @click=" hideImportModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <TheCustomFilePicker ref="filePicker" title="File import" :initialValue="filesImport"
                                    error="" :isReadOnly="false" :isRequire="false" :isMultiple="false"
                                    @onChange="(files) => { filesImport = files }" :acceptFile="acceptTypeExcel"
                                    :key="tempKey" />
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click=" hideImportModal()">&nbsp;Thoát</button>
                            <div class="pull-right">
                                <button type="button" class="btn btn-outline-info mr-1"
                                    @click="downloadImportSampleFile();">&nbsp;Download mẫu</button>
                                <button type="button" class="btn btn-outline-success"
                                    @click=" onImportSubmit();">&nbsp;Đọc dữ liệu File</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="importConfirmModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog"
                    style="max-width: 80%;margin-top: 1.75rem; margin-bottom: 1.75rem;margin-left: auto;margin-right: auto;position: relative;width: auto;pointer-events:none; overflow: hidden;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-danger">Xác nhận thông tin Import</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupImportConfirm">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!-- listColumn17-->
                        <div class="modal-body">
                            <div class="card">
                                <div class="card-body table-responsive p-0" style="max-height: 400px;">
                                    <table class="table table-head-fixed text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>Số thứ tự dòng</th>
                                                <th>Tên tài khoản</th>
                                                <th>Mật khẩu</th>
                                                <th>Họ tên</th>
                                                <th>Giới tính</th>
                                                <th>Email</th>
                                                <th>Số điện thoại</th>
                                                <th>Đơn vị ID</th>
                                                <th>Chức danh ID</th>
                                                <th>Quận huyện ID</th>
                                                <th>Phường xã ID</th>
                                                <th>Khóm ấp ID</th>
                                                <th>Tổ dân phố ID</th>
                                                <th>Đường phố ID</th>
                                                <th>Số nhà</th>
                                                <th>Địa chỉ</th>
                                                <th>Danh sách nhóm quyền ID</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="( item, index ) in listDataImport.sort((a, b) => parseInt(a.index) - parseInt(b.index))"
                                                :key="item.truongchuanQuocgiaId">
                                                <td :class="{ 'error-import-cell': errorRowList.includes(index) }">{{
                                                    item.index }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.userName && item.userName.toString().startsWith('Error:') }">
                                                    {{ item.userName && item.userName.toString().startsWith('Error:')
                                                        ?
                                                        item.userName.slice(6) : item.userName }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.password && item.password.toString().startsWith('Error:') }">
                                                    {{ item.password &&
                                                        item.password.toString().startsWith('Error:') ?
                                                        item.password.slice(6) : item.password }}
                                                </td>

                                                <td
                                                    :class="{ 'error-import-cell': item.hoTen && item.hoTen.toString().startsWith('Error:') }">
                                                    {{ item.hoTen && item.hoTen.toString().startsWith('Error:') ?
                                                        item.hoTen.slice(6) : item.hoTen }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.gioiTinh && item.gioiTinh.toString().startsWith('Error:') }">
                                                    {{ item.gioiTinh && item.gioiTinh.toString().startsWith('Error:') ?
                                                        item.gioiTinh.slice(6) : item.gioiTinh }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.email && item.email.toString().startsWith('Error:') }">
                                                    {{ item.email && item.email.toString().startsWith('Error:') ?
                                                        item.email.slice(6) : item.email }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.sdt && item.sdt.toString().startsWith('Error:') }">
                                                    {{ item.sdt &&
                                                        item.sdt.toString().startsWith('Error:') ?
                                                        item.sdt.slice(6) : item.sdt }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.donViId && item.donViId.toString().startsWith('Error:') }">
                                                    {{ item.donViId &&
                                                        item.donViId.toString().startsWith('Error:') ?
                                                        item.donViId.slice(6) : item.donViId }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.chucDanhId && item.chucDanhId.toString().startsWith('Error:') }">
                                                    {{ item.chucDanhId &&
                                                        item.chucDanhId.toString().startsWith('Error:') ?
                                                        item.chucDanhId.slice(6) : item.chucDanhId }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.quanHuyenId && item.quanHuyenId.toString().startsWith('Error:') }">
                                                    {{ item.quanHuyenId &&
                                                        item.quanHuyenId.toString().startsWith('Error:') ?
                                                        item.quanHuyenId.slice(6) : item.quanHuyenId }}
                                                </td>


                                                <td
                                                    :class="{ 'error-import-cell': item.phuongXaId && item.phuongXaId.toString().startsWith('Error:') }">
                                                    {{ item.phuongXaId &&
                                                        item.phuongXaId.toString().startsWith('Error:') ?
                                                        item.phuongXaId.slice(6) : item.phuongXaId }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.khomApId && item.khomApId.toString().startsWith('Error:') }">
                                                    {{ item.khomApId &&
                                                        item.khomApId.toString().startsWith('Error:') ?
                                                        item.khomApId.slice(6) : item.khomApId }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.toDanPhoId && item.toDanPhoId.toString().startsWith('Error:') }">
                                                    {{ item.toDanPhoId &&
                                                        item.toDanPhoId.toString().startsWith('Error:') ?
                                                        item.toDanPhoId.slice(6) : item.toDanPhoId }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.duongPhoId && item.duongPhoId.toString().startsWith('Error:') }">
                                                    {{ item.duongPhoId &&
                                                        item.duongPhoId.toString().startsWith('Error:') ?
                                                        item.duongPhoId.slice(6) : item.duongPhoId }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.soNha && item.soNha.toString().startsWith('Error:') }">
                                                    {{ item.soNha && item.soNha.toString().startsWith('Error:') ?
                                                        item.soNha.slice(6) : item.soNha }}
                                                </td>
                                                <td
                                                    :class="{ 'error-import-cell': item.diaChi && item.diaChi.toString().startsWith('Error:') }">
                                                    {{ item.diaChi && item.diaChi.toString().startsWith('Error:') ?
                                                        item.diaChi.slice(6) : item.diaChi }}
                                                </td>

                                                <td
                                                    :class="{ 'error-import-cell': item.listRoleId && item.listRoleId.toString().startsWith('Error:') }">
                                                    {{ item.listRoleId &&
                                                        item.listRoleId.toString().startsWith('Error:') ?
                                                        item.listRoleId.slice(6) : item.listRoleId }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- /.card-body -->
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hidePopupImportConfirm">&nbsp;Thoát</button>
                            <button v-if="errorRowList.length == 0 && listDataImport.length != 0" type="button"
                                class="pull-right btn btn-outline-success"
                                @click="onConfirmImportSubmit();">&nbsp;Import</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import * as XLSX from "xlsx";
import axios from 'axios';
import objectEnum from '@/config/object.env'
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
import TheCustomFilePicker from '@/components/shareComponents/TheCustomFilePicker.vue';
import { nguoiDungModel } from '@/models/quantri/nguoiDung.model'

export default {
    name: "TheNDQT",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheCustomFilePicker,
        // TheDatePicker,
        // TheInputTextSelect,
        // TheFilePicker,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadonly: null,
            isReadonlyUserName: null,

            modelRec: nguoiDungModel.newModel(),
            model: nguoiDungModel.newFEModel(),
            modelResetPassword: {
                userId: null,
                password: "",
                confirmPassword: "",
                errorPassword: null,
                errorConfirmPassword: null,
            },
            errors: nguoiDungModel.errors(),

            acceptTypeExcel: config.ACCEPT_TYPE_EXCEL,

            category_GIOITINH: config.GIOITINH,
            category_DONVI: [],
            category_CHUCDANH: [],
            category_cQUYEN: [],
            category_DUONGPHO: [],
            category_cQUANHUYEN: [],
            category_cPHUONGXA: [],
            category_cKHOMAP: [],
            category_cTODANPHO: [],

            sValue_ID: null,
            sValue_TENTAIKHOAN: null,
            sValue_HOTEN: null,
            sValue_DONVI: null,
            sValue_CHUCDANH: null,
            sValue_SORT: null,
            sValue_LOCKOUTENABLED: null,
            dValue_QUYEN: [],

            cLockoutEnable_Value: null,
            cLockoutEnable_Title: null,

            csList: [],
            csList_Title: "",
            csList_Code: null,
            sType_List: 1,

            exportDatas: [],
            exportJsonFields: {
                'User ID': 'userId',
                'Tên tài khoản': 'userName',
                'Họ tên': 'hoTen',
                'Giới tính': 'gioiTinh',
                'Email': 'email',
                'Số điện thoại': 'sdt',
                'Đơn vị ID': 'donViId',
                'Tên đơn vị': 'tenDonVi',
                'Chức danh ID': 'chucDanhId',
                'Tên chức danh': 'tenChucDanh',
                'Quận huyện ID': 'quanHuyenId',
                'Tên quận huyện': 'tenQuanHuyen',
                'Phường xã ID': 'phuongXaId',
                'Tên phường xã': 'tenPhuongXa',
                'Khóm ấp ID': 'khomApId',
                'Tên khóm ấp': 'tenKhomAp',
                'Tổ dân phố ID': 'toDanPhoId',
                'Tên tổ dân phố': 'tenToDanPho',
                'Đường phố ID': 'duongPhoId',
                'Tên đường phố': 'tenDuongPho',
                'Số nhà': 'soNha',
                'Địa chỉ': 'diaChi',
                'Tình trạng khóa': 'lockoutEnabled',
                'Thời gian khóa': 'lockoutTime',
                'Ngày khởi tạo': 'dateCreated',
                'Phân hệ ID': 'appId',
                'Tên phân hệ': 'appName',
            },

            filesImport: [],
            listDataImport: [],
            errorRowList: [],

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        ...mapActions('handleData', ['handleTypeImport',]),
        //...mapActions('adjustData', ['formatDateShow', 'fromDatetoString']),
        ...mapActions('nguoiDungQT', ['getPagingNguoiDungQT', 'getDetailNguoiDungQT', 'checkExistNguoiDungQT', 'createNguoiDungQT', 'updateNguoiDungQT', 'deleteNguoiDungQT', 'restoreNguoiDungQT', 'exportExcelNguoiDungQT', 'importExcelNguoiDungQT', 'handleListNguoiDungQT', 'setEnabledNguoiDungQT', 'lockAccountNguoiDungQT', 'unlockAccountNguoiDungQT', 'resetPasswordNguoiDungQT', 'getCustomDetailNguoiDungQT']),
        ...mapActions('chucDanh', ['getBasicChucDanh']),
        ...mapActions('donViQT', ['getBasicDonViQT']),
        ...mapActions('phanHeQT', ['getBasicPhanHeQT']),
        ...mapActions('quyenQT', ['getBasicQuyenQT']),
        ...mapActions('duongPhoDM', ['getBasicDuongPhoDM']),
        ...mapActions('quanHuyenDM', ['getBasicQuanHuyenDM']),
        ...mapActions('phuongXaDM', ['getBasicPhuongXaDM']),
        ...mapActions('khomApDM', ['getBasicKhomApDM']),
        ...mapActions('toDanPhoDM', ['getBasicToDanPhoDM']),

        async setup() {
            let header = 'Quản trị người dùng'
            this.setupHeader({ header })
        },

        async initialize() {
            // $(".select2bs4").select2({
            //     theme: "bootstrap4",
            // })
            // $('#my-colorpicker').colorpicker()
            // $('#timepicker').datetimepicker({ use24hours: true, format: 'HH:mm' })

            $('#gioiTinh_sOptions').on('change', e => {
                let targetValue = e.target.value ? e.target.value : null
                if (!targetValue || targetValue == '') {
                    this.sValue_GIOITINH = null
                    this.handlePageChange(1)
                }
                else {
                    let valueSelect = this.category_GIOITINH.filter(e => e.id == targetValue)[0] ? this.category_GIOITINH.filter(e => e.id == targetValue)[0] : null
                    this.sValue_GIOITINH = valueSelect.id
                    this.handlePageChange(1)
                }
            });

            $('#donVi_sOptions').on('change', e => {
                let targetValue = e.target.value ? e.target.value : null
                if (!targetValue || targetValue == '') {
                    this.sValue_DONVI = null
                    this.handlePageChange(1)
                }
                else {
                    let valueSelect = this.category_DONVI.filter(e => e.id == targetValue)[0] ? this.category_DONVI.filter(e => e.id == targetValue)[0] : null
                    this.sValue_DONVI = valueSelect.id
                    this.handlePageChange(1)
                }
            });

            $('#chucDanh_sOptions').on('change', e => {
                let targetValue = e.target.value ? e.target.value : null
                if (!targetValue || targetValue == '') {
                    this.sValue_CHUCDANH = null
                    this.handlePageChange(1)
                }
                else {
                    let valueSelect = this.category_CHUCDANH.filter(e => e.id == targetValue)[0] ? this.category_CHUCDANH.filter(e => e.id == targetValue)[0] : null
                    this.sValue_CHUCDANH = valueSelect.id
                    this.handlePageChange(1)
                }
            });

            $('#LockoutEnabled_sOptions').on('change', e => {
                let a = e.target.value
                let returnValue = null
                switch (a) {
                    case "true":
                        returnValue = true
                        break
                    case "false":
                        returnValue = false
                        break
                    default:
                        returnValue = null
                }
                this.sValue_LOCKOUTENABLED = returnValue
                this.getData()
            });

        },

        async showModal() {
            $('#insUpdModal').modal('show')

        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
            // await this.getData()
        },

        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },
        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
            //await this.getData()
        },
        async showLockoutEnabledConfirmModal() {
            $('#lockoutEnabledConfirmModal').modal('show')
        },
        async hideLockOutLockoutEnabledConfirmModal() {
            $('#lockoutEnabledConfirmModal').modal('hide')
        },

        async showResetPasswordModal() {
            $('#resetPasswordModal').modal('show')

        },
        async hideResetPasswordModal() {
            $('#resetPasswordModal').modal('hide')
            // await this.getData()
        },

        async showImportModal() {
            this.listDataImport = [];
            this.errorRowList = [];
            this.filesImport = [];
            this.tempKey = common.randomString(10),
                $('#importModal').modal('show');
        },
        async hideImportModal() {
            $('#importModal').modal('hide');
        },

        async showPopupImportConfirm() {
            $('#importConfirmModal').modal('show')
        },
        async hidePopupImportConfirm() {
            $('#importConfirmModal').modal('hide')
        },

        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.sValue_SORT = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },

        async changeQuyen(objects) {
            if (objects[0] == '') {
                objects.splice(0, 1);
            }
            let temp = String(objects).split(',')
            this.model.listRoleId = temp
            //= this.category_cQUYEN.filter(e => temp.includes(e.id));

        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == 2) this.sType_List = 1
            else if (this.sType_List == 1) this.sType_List = 2
            await this.handlePageChange(1)
        },

        async selectRow(id) {
            if (this.csList.includes(id)) {
                this.csList.splice(this.csList.indexOf(id), 1)
            }
            else {
                this.csList.push(id)
            }
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList = this.items.map((item) => {
                    return item.userId
                })
            }
            else {
                this.csList = []
            }
        },

        async openConfirmLockoutEnabledChange(item) {
            this.cLockoutEnable_Value = item
            let presentValue = this.cLockoutEnable_Value.lockoutEnabledDisplay
            if (presentValue == true)
                this.cLockoutEnable_Title = "mở khóa"
            else if (presentValue == false)
                this.cLockoutEnable_Title = "khóa"

            this.showLockoutEnabledConfirmModal()

        },

        async updateLockoutEnabled() {
            let model = {
                userId: this.cLockoutEnable_Value.userId,
            }
            let typeChange = this.cLockoutEnable_Value.lockoutEnabledDisplay
            if (typeChange == true) {
                await this.lockAccountNguoiDungQT({ model: model }).then(resp => {
                    this.hideLockOutLockoutEnabledConfirmModal()
                });
            }
            else if (typeChange == false) {
                await this.unlockAccountNguoiDungQT({ model: model }).then(resp => {
                    this.hideLockOutLockoutEnabledConfirmModal()
                });
            }

        },

        async closeConfirmLockOutEnabledChange() {
            this.cLockoutEnable_Value.lockoutEnabledDispla = !this.cLockoutEnable_Value.lockoutEnabledDisplay
            $('#item' + this.cLockoutEnable_Value.userId).prop('checked', this.cLockoutEnable_Value.lockoutEnabledDisplay);
            await this.hideLockOutLockoutEnabledConfirmModal()
        },

        //async onChange_cPhanHe(e) {
        //    let targetValue = e ? e : null
        //    if (!targetValue || targetValue == '') {
        //        let a
        //    }
        //    else {
        //        let valueSelect = this.category_cPHANHE.filter(e => e.id == targetValue)[0] ? this.category_cPHANHE.filter(e => e.id == targetValue)[0] : null
        //        //
        //        this.category_cQUYEN = await this.getCategory_QUYEN(valueSelect.id)
        //        //
        //    }
        //},

        async onChange_cQuanHuyen(e) {
            let targetValue = e ? e : null
            if (!targetValue || targetValue == '') {
                this.model.quanHuyenId = null
                //
                this.category_cPHUONGXA = []
                this.model.phuongXaId = null
                this.category_cKHOMAP = []
                this.model.khomApId = null
                this.category_cTODANPHO = []
                this.model.toDanPhoId = null
                //
            }
            else {
                let valueSelect = this.category_cQUANHUYEN.filter(e => e.id == targetValue)[0] ? this.category_cQUANHUYEN.filter(e => e.id == targetValue)[0] : null
                this.model.quanHuyenId = valueSelect.id
                //
                this.category_cPHUONGXA = []
                this.model.phuongXaId = null
                this.category_cKHOMAP = []
                this.model.khomApId = null
                this.category_cTODANPHO = []
                this.model.toDanPhoId = null
                this.category_cPHUONGXA = await this.getCategory_PHUONGXA(valueSelect.id)
                //
            }
        },

        async onChange_cPhuongXa(e) {
            let targetValue = e ? e : null
            if (!targetValue || targetValue == '') {
                this.model.phuongXaId = null
                //
                this.category_cKHOMAP = []
                this.model.khomApId = null
                this.category_cTODANPHO = []
                this.model.toDanPhoId = null
                //
            }
            else {
                let valueSelect = this.category_cPHUONGXA.filter(e => e.id == targetValue)[0] ? this.category_cPHUONGXA.filter(e => e.id == targetValue)[0] : null
                this.model.phuongXaId = valueSelect.id
                //
                this.category_cKHOMAP = []
                this.model.khomApId = null
                this.category_cTODANPHO = []
                this.model.toDanPhoId = null
                this.category_cKHOMAP = await this.getCategory_KHOMAP(valueSelect.id)
                //
            }
        },

        async onChange_cKhomAp(e) {
            let targetValue = e ? e : null
            if (!targetValue || targetValue == '') {
                this.model.khomApId = null
                //
                this.category_cTODANPHO = []
                this.model.toDanPhoId = null
                //
            }
            else {
                let valueSelect = this.category_cKHOMAP.filter(e => e.id == targetValue)[0] ? this.category_cKHOMAP.filter(e => e.id == targetValue)[0] : null
                this.model.khomApId = valueSelect.id
                //
                this.category_cTODANPHO = []
                this.model.toDanPhoId = null
                this.category_cTODANPHO = await this.getCategory_TODANPHO(valueSelect.id)
                //
            }
        },
        async searchChangeDonVi(e) {
            this.sValue_DONVI = e == "" ? null : e
            this.handlePageChange(1)
        },
        async searchChangeChucDanh(e) {
            this.sValue_CHUCDANH = e == "" ? null : e
            this.handlePageChange(1)
        },
        async getData() {
            this.isBusy = true
            this.csList = []
            let params = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                userName: this.sValue_TENTAIKHOAN,
                hoTen: this.sValue_HOTEN,
                donViId: this.sValue_DONVI,
                chucDanhId: this.sValue_CHUCDANH,
                sort: this.sValue_SORT,
                lockoutEnabled: this.sValue_LOCKOUTENABLED,
            }
            await this.getPagingNguoiDungQT({ params: params, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].lockoutEnabledDisplay = this.items[i].lockoutEnabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            if (this.code == 'delete' && this.sType_List == 2) this.title = this.$t('labels.deleteReal')
            this.styleButton = this.$t('labels.styleButton' + code)
            this.styleTitle = this.$t('labels.styleTitle' + code)
            this.errors = nguoiDungModel.errors()

            if (this.code == 'update' || this.code == 'delete' || this.code == 'restore') {
                let params = {
                    userId: item.userId
                }
                let resp = await this.getCustomDetailNguoiDungQT({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = nguoiDungModel.newModel()
                        this.modelRec = resp.userInfo
                        this.modelRec.roleInfo = resp.roleInfo
                        this.modelRec.appInfo = resp.appInfo
                        this.model = nguoiDungModel.parseModeltoFEModel(this.modelRec)
                        this.dValue_QUYEN = this.modelRec.roleInfo ? this.modelRec.roleInfo.map(item => item.id) : []
                        this.model.listRoleId = this.dValue_QUYEN ? String(this.dValue_QUYEN).split(',') : null
                        //this.triggerDetail()
                        //this.isReadonly = (code == "create") ? false : true
                    }
                });
                if (this.model.quanHuyenId) this.category_cPHUONGXA = await this.getCategory_PHUONGXA(this.model.quanHuyenId)
                if (this.model.phuongXaId) this.category_cKHOMAP = await this.getCategory_KHOMAP(this.model.phuongXaId)
                if (this.model.khomApId) this.category_cTODANPHO = await this.getCategory_TODANPHO(this.model.khomApId)
                if (this.model.appId) this.category_cQUYEN = await this.getCategory_QUYEN(this.model.appId)
                this.isReadonly = (code == "delete" || code == "restore") ? true : false
                this.isReadonlyUserName = true
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == 'detail') {
                let params = {
                    userId: item.userId
                }
                await this.getCustomDetailNguoiDungQT({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {

                        this.modelRec = nguoiDungModel.newModel()
                        this.modelRec = resp.userInfo
                        this.modelRec.roleInfo = resp.roleInfo
                        this.modelRec.appInfo = resp.appInfo
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else if (this.code == 'reset') {
                let itemId = item.userId
                this.modelResetPassword = {
                    userId: itemId,
                    password: "",
                    confirmPassword: "",
                    errorPassword: null,
                    errorConfirmPassword: null,
                },
                    await this.showResetPasswordModal()
            }
            else {

                this.model = nguoiDungModel.newFEModel()
                this.dValue_QUYEN = []
                //this.triggerDetail()
                this.isReadonly = (code == "create") ? false : true
                this.isReadonlyUserName = false
                //this.isReadonly = this.isReadonly = (code == "delete") ? true : false
                // show popup
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },
        async validateResetPassword() {
            let isvalid = true
            this.modelResetPassword.errorPassword = null
            this.modelResetPassword.errorConfirmPassword = null
            if (!await this.validateRequired(this.modelResetPassword.password)) {
                this.modelResetPassword.errorPassword = "Nhập mật khẩu"
                isvalid = false
            }
            if (!await this.validateRequired(this.modelResetPassword.confirmPassword)) {
                this.modelResetPassword.errorConfirmPassword = "Nhập xác nhận mật khẩu"
                isvalid = false
            }
            return isvalid
        },

        async validate(model) {
            let isvalid = true
            this.errors = nguoiDungModel.errors()
            if (!await this.validateRequired(model.userName)) {
                this.errors.userName = "Nhập tên"
                isvalid = false
            }
            else if (this.code == "update" && this.modelRec.userName != model.userName) {
                if (await this.checkExistName(model.userName)) {
                    this.errors.userName = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            else if (this.code == "create") {
                if (await this.checkExistName(model.userName)) {
                    this.errors.userName = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }

            if (!await this.validateRequired(model.hoTen)) {
                this.errors.hoTen = "Nhập họ tên"
                isvalid = false
            }


            if (!await this.validateRequired(model.sdt)) {
                this.errors.sdt = "Nhập số điện thoại"
                isvalid = false
            }

            if (!await this.validateRequired(model.password) && (this.code == "create")) {
                this.errors.password = "Nhập mật khẩu"
                isvalid = false
            }

            if (!await this.validateRequired(model.listRoleId)) {
                this.errors.listRoleId = "Phải chọn ít nhất một quyền cho tài khoản"
                isvalid = false
            }



            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = nguoiDungModel.newModel()
            if (this.code == "update" || this.code == "delete" || this.code == "restore") sendModel.userId = FEmodel.userId
            if (this.code == "create") sendModel.password = FEmodel.password
            sendModel.userName = FEmodel.userName

            sendModel.hoTen = FEmodel.hoTen
            sendModel.gioiTinh = FEmodel.gioiTinh == "" ? null : FEmodel.gioiTinh
            sendModel.email = FEmodel.email
            sendModel.sdt = FEmodel.sdt
            sendModel.donViId = FEmodel.donViId == "" ? null : FEmodel.donViId
            sendModel.chucDanhId = FEmodel.chucDanhId == "" ? null : FEmodel.chucDanhId
            sendModel.quanHuyenId = FEmodel.quanHuyenId == "" ? null : FEmodel.quanHuyenId
            sendModel.phuongXaId = FEmodel.phuongXaId == "" ? null : FEmodel.phuongXaId
            sendModel.khomApId = FEmodel.khomApId == "" ? null : FEmodel.khomApId
            sendModel.toDanPhoId = FEmodel.toDanPhoId == "" ? null : FEmodel.toDanPhoId
            sendModel.duongPhoId = FEmodel.duongPhoId == "" ? null : FEmodel.duongPhoId
            sendModel.soNha = FEmodel.soNha
            sendModel.diaChi = FEmodel.diaChi
            sendModel.listRoleId = FEmodel.listRoleId ? FEmodel.listRoleId.toString() : null

            sendModel.lockoutEnabled = FEmodel.lockoutEnabledDisplay ? FEmodel.lockoutEnabledDisplay : false

            return sendModel
        },

        async onResetPasswordSubmit() {
            if (await this.validateResetPassword()) {
                let model = this.modelResetPassword
                if (model.password !== model.confirmPassword) {
                    this.$store.dispatch("alert/error", "Mật khẩu xác nhận không chính xác!", { root: true });
                }
                else {
                    let sendModel = {
                        userId: model.userId,
                        password: model.password
                    }
                    let res = await this.resetPasswordNguoiDungQT({ model: sendModel })
                    if (res) {
                        await this.getData()
                        this.hideResetPasswordModal()
                    }
                    //this.$store.dispatch("alert/success", "Reset mật khẩu thành công", { root: true });
                }
            }

        },
        async onSubmit() {
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            let params = null
            switch (code) {
                case "create":
                    if (await this.validate(sendModel)) {
                        res = await this.createNguoiDungQT({ model: sendModel })
                        if (res) {
                            await this.getData()
                            this.hideModal()
                        }
                    }
                    break
                case "update":
                    if (await this.validate(sendModel)) {
                        res = await this.updateNguoiDungQT({ model: sendModel })
                        if (res) {
                            await this.getData()
                            this.hideModal()
                        }
                    }
                    break
                case "delete":
                    // eslint-disable-next-line
                    params = {
                        userId: sendModel.userId
                    }
                    res = await this.deleteNguoiDungQT({ model: params, type: this.sType_List })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "deleteReal":
                    // eslint-disable-next-line
                    params = {
                        userId: sendModel.userId
                    }
                    res = await this.deleteNguoiDungQT({ model: params, type: this.sType_List })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "restore":
                    // eslint-disable-next-line
                    res = await this.restoreNguoiDungQT({ model: sendModel })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                default:
            }
        },

        async confirmList(code) {
            if (this.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Code = code
                if (code == 'delete') this.csList_Title = "Xóa"
                else if (code == 'deleteReal') this.csList_Title = "Xóa hoàn toàn"
                else if (code == 'restore') this.csList_Title = "Khôi phục"
                else if (code == 'offEnabled') this.csList_Title = "Tắt hiển thị"
                else if (code == 'onEnabled') this.csList_Title = "Bật hiển thị"
                this.showPopupconfirmcsListModal()
            }

        },

        async onSubmitList() {
            let code = this.csList_Code
            let t = null
            let params = {
                listId: this.csList.toString()
            }
            // if(code == "offEnebaled") params.enabled = false
            // else if(code == "onEnebaled") params.enabled = true
            let res = null
            switch (code) {
                case "delete":
                    res = await this.handleListNguoiDungQT({ model: params, type: 1 })
                    break
                case "deleteReal":
                    res = await this.handleListNguoiDungQT({ model: params, type: 2 })
                    break
                case "restore":
                    res = await this.handleListNguoiDungQT({ model: params, type: 3 })
                    break
                case "offEnabled":
                    params.enabled = false
                    res = await this.handleListNguoiDungQT({ model: params, type: 4 })
                    break
                case "onEnabled":
                    params.enabled = true
                    res = await this.handleListNguoiDungQT({ model: params, type: 4 })
                    break
                default:
            }
            if (res) {
                await this.getData()
                this.hidePopupconfirmcsListModal()
            }
        },
        async checkExistName(name) {
            let params = {
                userName: name
            }
            let res = await this.checkExistNguoiDungQT({ params: params })
            return res.data

        },

        async exportExcel() {
            let params = {
                userName: this.sValue_TENTAIKHOAN,
                hoTen: this.sValue_HOTEN,
                donViId: this.sValue_DONVI,
                chucDanhId: this.sValue_CHUCDANH,
                sort: this.sValue_SORT,
                lockoutEnabled: this.sValue_LOCKOUTENABLED,
            }
            await this.exportExcelNguoiDungQT({ params: params }).then(res => {
                this.exportDatas = res ? res : {}
            });
        },

        //#region ImportData
        async onImportSubmit() {
            if (this.filesImport[0]) {
                let results = await this.handleImportData();
                if (results) {
                    this.hideImportModal()
                    this.showPopupImportConfirm()
                }
                else {
                    this.$store.dispatch("alert/error", "Có lỗi trong quá trình xử lý dữ liệu Import!", { root: true });
                }
            }
            else {
                this.$store.dispatch("alert/warning", "Vui lòng chọn tập tin để Import!", { root: true });
            }
        },




        async handleImportData() {
            this.listDataImport = [];
            if (this.filesImport[0]) {
                return await new Promise((resolve, reject) => {
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        /* Parse data */
                        const bstr = e.target.result;
                        const wb = XLSX.read(bstr, { type: 'binary' });
                        /* Get first worksheet */
                        const wsname = wb.SheetNames[0];
                        const ws = wb.Sheets[wsname];
                        /* Convert array of arrays */
                        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                        const filteredData = [];
                        data.forEach((row, index) => {
                            if (row.some(cell => cell !== '' && cell !== null && cell !== undefined)) {
                                row.rowNumber = index + 1; // Thêm thuộc tính rowNumber vào mỗi dòng
                                filteredData.push(row);
                            }
                        });
                        filteredData.splice(0, 1);
                        filteredData.forEach(async (element, index) => {
                            // -- listColumn27 -- 
                            let import_DATA = Object();
                            import_DATA.index = element.rowNumber ? (element.rowNumber + 1) : null;
                            import_DATA.userName = await this.handleTypeImport({ input: element[0], typeData: objectEnum.handleData.STRING, required: true });
                            import_DATA.password = await this.handleTypeImport({ input: element[1], typeData: objectEnum.handleData.STRING, required: true });
                            import_DATA.hoTen = await this.handleTypeImport({ input: element[2], typeData: objectEnum.handleData.STRING, required: true });
                            import_DATA.gioiTinh = await this.handleTypeImport({ input: element[3], typeData: objectEnum.handleData.INT, required: false });
                            import_DATA.email = await this.handleTypeImport({ input: element[4], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.sdt = await this.handleTypeImport({ input: element[5], typeData: objectEnum.handleData.STRING, required: true });
                            import_DATA.donViId = await this.handleTypeImport({ input: element[6], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.chucDanhId = await this.handleTypeImport({ input: element[7], typeData: objectEnum.handleData.INT, required: false });
                            import_DATA.quanHuyenId = await this.handleTypeImport({ input: element[8], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.phuongXaId = await this.handleTypeImport({ input: element[9], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.khomApId = await this.handleTypeImport({ input: element[10], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.toDanPhoId = await this.handleTypeImport({ input: element[11], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.duongPhoId = await this.handleTypeImport({ input: element[12], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.soNha = await this.handleTypeImport({ input: element[13], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.diaChi = await this.handleTypeImport({ input: element[14], typeData: objectEnum.handleData.STRING, required: false });
                            import_DATA.listRoleId = await this.handleTypeImport({ input: element[15], typeData: objectEnum.handleData.STRING, required: true });

                            let exists = JSON.stringify(import_DATA).includes("Error: ");
                            if (exists) {
                                this.errorRowList.push(index);
                            } this.listDataImport.push(import_DATA);
                        });
                        return resolve(true);
                    }
                    reader.onerror = function (e) {
                        reject(false);
                    };
                    reader.readAsBinaryString(this.filesImport[0]);

                    // const blob = new Blob(['hello']);
                    // const reader = new FileReader();
                    // reader.onload = e => {
                    //     const dataURL = reader.result;
                    //     const base64 = dataURL.slice(dataURL.indexOf(',') + 1);
                    //     console.log(base64);
                    // };
                    // reader.readAsDataURL(blob);

                });
            }
            else return false;
        },

        async onConfirmImportSubmit() {
            if (this.errorRowList.length == 0) {
                let importPush = {
                    listData: null,
                };
                //re-fix data
                for (let i = 0; i < this.listDataImport.length; i++) {
                    if (this.listDataImport[i].gioiTinh == "FALSE")
                        this.listDataImport[i].gioiTinh = '0'
                    else if (this.listDataImport[i].gioiTinh == "TRUE")
                        this.listDataImport[i].gioiTinh = '1'
                }

                //
                importPush.listData = this.listDataImport;
                let result = await this.importExcelNguoiDungQT({ item: importPush });
                this.hidePopupImportConfirm()
                if (result === true)
                    await this.getData();
            }
        },

        async downloadImportSampleFile() {
            let filename = 'NguoiDung_ImportSample.xlsx';
            let pathFile = objectEnum.IMPORT_SAMPLE_FILE_PATH + filename;
            try {
                const response = await axios.get(pathFile, {
                    responseType: 'blob', // Khai báo kiểu dữ liệu là blob.
                });

                // Tạo một đường dẫn tạm thời và tạo ra một liên kết ẩn để tải xuống.
                const tempUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = tempUrl;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();

                // Giải phóng đường dẫn tạm thời sau khi tải xuống hoàn tất.
                window.URL.revokeObjectURL(tempUrl);
            } catch (error) {
                console.error('Lỗi khi tải tập tin:', error);
            }
        },

        //#endregion ImportData

        async getCategory_CHUCDANH() {
            let params = {

            }
            let res = await this.getBasicChucDanh({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].chucDanhId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_DONVI() {
            let params = {

            }
            let res = await this.getBasicDonViQT({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].donViId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_PHANHE() {
            let params = {

            }
            let res = await this.getBasicPhanHeQT({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].appId,
                            name: res[i].appName
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_QUYEN(appId) {
            let params = {
                appId: appId
            }
            let res = await this.getBasicQuyenQT({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].id,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_QUANHUYEN() {
            let params = {
                tinhTpId: config.TINHTP_SITEID
            }
            let res = await this.getBasicQuanHuyenDM({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].quanHuyenId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_PHUONGXA(quanHuyenId) {
            let params = {
                quanHuyenId: quanHuyenId
            }
            let res = await this.getBasicPhuongXaDM({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].phuongXaId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_KHOMAP(phuongXaId) {
            let params = {
                phuongXaId: phuongXaId
            }
            let res = await this.getBasicKhomApDM({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].khomApId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_TODANPHO(khomApId) {
            let params = {
                khomApId: khomApId
            }
            let res = await this.getBasicToDanPhoDM({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].toDanPhoId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_DUONGPHO() {
            let params = {

            }
            let res = await this.getBasicDuongPhoDM({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].duongPhoId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },

    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()

        this.category_CHUCDANH = await this.getCategory_CHUCDANH()
        this.category_DONVI = await this.getCategory_DONVI()
        //this.category_cPHANHE = await this.getCategory_PHANHE()
        this.category_cQUYEN = await this.getCategory_QUYEN(null)
        this.category_DUONGPHO = await this.getCategory_DUONGPHO()
        this.category_cQUANHUYEN = await this.getCategory_QUANHUYEN()
    }


}
</script>
<style></style>